// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f13e7aa1","455":"ed8dddc9","977":"3f6548c7"}[chunkId] + ".chunk.js";
};